module.exports = __webpack_public_path__ + "img/logo_jetfloat.bbdc4722.svg";